import { render, staticRenderFns } from "./SettingsCustomizationsForm.vue?vue&type=template&id=c129e5f2&scoped=true&"
import script from "./SettingsCustomizationsForm.vue?vue&type=script&lang=js&"
export * from "./SettingsCustomizationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c129e5f2",
  null
  
)

export default component.exports